import React, { Component } from "react";
import '../rnr.css';

class Home extends Component {
  render() {
    return (
      <main className="flex-shrink-0">
        <div className="container">
          <h4 className="mt-3">SCI-ASEAN Green Research Hackathon - Technical Challenge #2</h4>
          <p className="lead">Problem Statement</p>
          <blockquote>Use technology to develop an innovative green insurance product incorporating environmental considerations in its design and execution. 
            The insurance product can be for retail or commercial policyholders and can be either life or general insurance. 
            It can be a traditional direct insurance or reinsurance product or alternative transfer-based product such as a parametric based solution.
          </blockquote>
          <p className="lead">Team</p>
          <p>Return and Risk</p>
          <p className="lead">Solution</p>
          <ul>
            <li>Proof of concept AWS cloud-native web app</li>
            <li>Enables the design and pricing of innovative climate-based parametric insurance solutions</li>
            <li>Frontend is a React app</li>
            <li>Backend uses AWS serverless architecture e.g. API Gateway, Lambda functions</li>
          </ul>
        </div>
      </main>
    );
  }
}
 
export default Home;